module.exports = __webpack_public_path__ + "static/media/person_pintarnya.1b7e4fa1.png";